import { Form, Input } from "antd";
import React from "react";

const WorkerShortName: React.FC = () => {
  return (
    <Form.Item
      name="shortName"
      label="Short Name"
      rules={[
        {
          required: true,
          message: "Please enter the short name",
        },
      ]}
    >
      <Input />
    </Form.Item>
  );
};

export default WorkerShortName;
